<template>
  <div id="responses-summary-view">
    <div class="response-container" v-for="response in questions" :key="response.CommentID">
      <ShortAnswerContainer v-if="response.QuestionType === 'short answer'" :question="response" />
      <LikertAnswerContainer v-if="displayLikert(response)" :question="response" />
    </div>
  </div>
</template>

<script>
import ShortAnswerContainer from "./ShortAnswerContainer.vue";
import LikertAnswerContainer from "./LikertAnswerContainer.vue";

export default {
  props: {
    questions: {
      type: Object,
      required: true
    }
  },
  components: {
    ShortAnswerContainer,
    LikertAnswerContainer
  },
  methods: {
    displayLikert(response) {
      return (
        response.QuestionType === "likert-type" &&
        response.responses.length >= 5
      );
    }
  }
};
</script>

<style scoped>
.response-container {
  margin-bottom: 2em;
}
</style>